import { TestIdClassNameProps } from "@app/types/Common";
import { Field } from "@app/types/Cue";
import { Name } from "@app/types/enums";
import { getFieldValue } from "@util/helpers";
import { isString } from "lodash-es";

import DynamicIframe from "./DynamicIframe";

export type DynamicIframeWrapperProps = TestIdClassNameProps & {
  fields: Field[];
  annotation: string;
};

export default function DynamicIframeWrapper({
  testId,
  fields,
  annotation,
}: DynamicIframeWrapperProps) {
  const source = getFieldValue(fields, Name.DynamicIframe);

  return (
    <>
      {source && isString(source) ? (
        <DynamicIframe
          testId={testId}
          source={source}
          annotation={annotation}
          rootClassName="mb-6"
        />
      ) : null}
    </>
  );
}
